import { render } from "./ProductsCarHeader.vue?vue&type=template&id=6db66c8c"
import script from "./ProductsCarHeader.vue?vue&type=script&lang=js"
export * from "./ProductsCarHeader.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./ProductsCarHeader.vue?vue&type=style&index=0&id=6db66c8c&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script